import React, { useState } from 'react';
import { generateCurrentFY, generateFYList, isTwoObjectsEqual } from '../../helpers/common';
import { Button, InputGroupText } from 'reactstrap';
import Select from 'react-select';
import PoliciesAndClaimAmount from '../../components/Dashboard/PoliciesAndClaimAmount';
import ClaimStatusCountTracker from '../../components/Dashboard/ClaimStatusCountTracker';

export default function Index() {
    const FY = generateFYList(3, 1);
    const FYList = FY.FYList;

    const { currentFY } = generateCurrentFY();
    const selectedFinancialYear = FYList.find(e => e.value == currentFY)

    const [filter, setFilter] = useState({
        financialYear: currentFY,
    });
    const [searchFilter, setSearchFilter] = useState(filter); // Use this to track the search filter

    const resetSearchTerm = () => {
        setFilter({
            financialYear: currentFY,
        });
        setSearchFilter({
            financialYear: currentFY,
        });
    };

    const selectSearch = async () => {
        setSearchFilter(filter); // Update searchFilter with the latest filter state
    };

    return (

        <>
            <div>
                <div>
                    <div className="my-3">
                        <div className="Body_topBar2nd_v2 dashboard_topBar2nd_v2">
                            <div className="d-flex left">
                                <Select
                                    options={FYList}
                                    className=""
                                    getOptionValue={x => x.value}
                                    getOptionLabel={x => x.label}
                                    onChange={option => {
                                        if (option) {
                                            setFilter({
                                                financialYear: option.value
                                            });
                                        } else {
                                            setFilter({
                                                financialYear: selectedFinancialYear
                                            });
                                        }
                                    }}
                                    autoComplete="off"
                                    value={filter.financialYear ? FYList.find((fy) => filter.financialYear == fy.value) : ''}
                                    placeholder="Financial Year"
                                />
                                <InputGroupText className="searchButton idividualButton">
                                    <Button
                                        color="link"
                                        className="p-0"
                                        disabled={isTwoObjectsEqual(searchFilter, filter)}
                                        onClick={selectSearch}
                                    >
                                        <i className="bx bx-search"></i>
                                    </Button>
                                </InputGroupText>

                                <Button
                                    color="primary"
                                    className="blueRefreshButton ms-2"
                                    onClick={resetSearchTerm}
                                >
                                    <i className="bx bx-refresh"></i>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-md-12 col-12'>
                    <PoliciesAndClaimAmount filter={searchFilter} />
                    <ClaimStatusCountTracker filter={searchFilter} />
                </div>
            </div>
        </>
    );
}